import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../../store';
import {
  deleteProducts,
  selectProducts
} from '../../../../store/products';
import { ProductId } from '../../../../store/types';

export const useProductsForDeletion = () => {
  const dispatch: AppDispatch = useDispatch();
  const [deletedIds, setDeleted] = useState([]);
  const products = useSelector(selectProducts);
  const onDelete = (id: ProductId) =>
    setDeleted((prev) => [...prev, id]);
  const onCancel = (id: ProductId) =>
    setDeleted((prev) =>
      prev.filter((item) => item.id !== id)
    );

  useEffect(() => {
    if (deletedIds.length > 0) {
      const productsForDeletionIds =
        Object.values(products)?.filter(
          (product) => product.forDeletion && product.id
        ) || [];

      if (
        productsForDeletionIds.length === deletedIds.length
      ) {
        setDeleted([]);
        dispatch(deleteProducts(deletedIds));
      }
    }
  }, [products, deletedIds, dispatch]);

  return {
    onDelete,
    onCancel
  };
};
